import {
    createFeatureReducer,
    FeatureActionReducer,
    PayloadAction
} from '../../store/store.utils';
import { UserAuth } from './auth.state';
import { AuthState, initialAuthState } from './auth.state';
import { AuthErrorCode } from '../../../../common/models/auth-api.interface';
import { HybridFrameSection } from '../../hybrid/hybrid.service';

abstract class AuthActionReducer extends FeatureActionReducer<AuthState> {
    protected constructor(name: string) {
        super('Auth', name);
    }
}

export class InvalidateJWT extends AuthActionReducer {
    constructor() {
        super('Invalidate JWT');
    }
    reduce(state: AuthState): AuthState {
        return {
            ...state,
            data: {
                ...state.data,
                claims: null,
                jwt: null
            }
        };
    }
}

export class ValidateJWTRequest extends AuthActionReducer {
    constructor() {
        super('Validate Request');
    }
    reduce(state: AuthState): AuthState {
        return {
            ...state,
            ui: {
                showFrame: true
            }
        };
    }
}

export class ValidateJWTSuccess
    extends AuthActionReducer
    implements PayloadAction<UserAuth> {
    constructor(public readonly payload: UserAuth) {
        super('Validate Success');
    }
    reduce(state: AuthState): AuthState {
        return {
            ui: {
                showFrame: false
            },
            data: {
                jwt: this.payload.jwt,
                claims: this.payload.claims,
                isInternal:
                    this.payload.claims?.preferred_username?.endsWith(
                        '@quotient.com'
                    ) ||
                    this.payload.claims?.preferred_username?.endsWith(
                        '@neptuneretailsolutions.com'
                    )
            }
        };
    }
}

export class ValidateJWTError
    extends AuthActionReducer
    implements
        PayloadAction<{ authErrorCode: AuthErrorCode; framed: boolean }> {
    constructor(
        public readonly payload: {
            authErrorCode: AuthErrorCode;
            framed: boolean;
        }
    ) {
        super('Validate Error');
    }
    reduce(state: AuthState): AuthState {
        return {
            ui: {
                showFrame: false
            },
            data: {
                jwt: null,
                claims: null,
                isInternal: false
            }
        };
    }
}

export class SetInvalidJWT
    extends AuthActionReducer
    implements PayloadAction<string> {
    constructor(public readonly payload: string) {
        super('Set Invalid JWT');
    }
    reduce(state: AuthState): AuthState {
        return {
            ui: {
                showFrame: false
            },
            data: {
                ...state.data,
                jwt: this.payload
            }
        };
    }
}

const typedReducer = createFeatureReducer(AuthActionReducer, initialAuthState);
export function authReducer(state: any, action: any) {
    return typedReducer(state, action);
}
